import React from 'react'
import StatCard from '../../../../Components/StatCard/StatCard';

function SalesStats() {
    return (
        <div className="grid grid-cols-4 gap-x-3 mt-4">
            <StatCard 
                statName="Total Sales"
                statValue={0}
                hasPrice={true}
                // statTrend={12}
            />
            <StatCard 
                statName="Average Order Value"
                statValue={0}
                hasPrice={true}
                // statTrend={12}
            />
            <StatCard 
                statName="Total Orders"
                statValue={0}
                // statTrend={-24}
            />
            <StatCard 
                statName="Return Rate"
                statValue={0}
                hasPercent={true} 
                // statTrend={-24}
            />
        </div>
    );
}

export default SalesStats;
